import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom"
import axios from "axios";
import { Backdrop } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import 'react-datepicker/dist/react-datepicker.css';
import './../Landing/LandingComponent.css';
import Header from "../../components/Header/Header";
import NewNavBar from "../../components/NewNavBar/NewNavBar";
import Sidebar from "../../components/Sidebar/Sidebar";
import environment from "../../environment/environment";
import aboutus from '../../assets/images/about1.png';
import about2 from '../../assets/images/about2.png';
import Footer from "../../components/Footer/Footer";
import CustomSpinner from "../../components/CustomeSpinner/CustomeSpinner";
import UpcomingTrips from "../UpcomingTrips/UpcomingTrips";
import JourneyFrames from "../JourneyFrames/JourneyFrames";
import YoutubeSection from "../YoutubeSection/YoutubeSection";

const messages = [
    "Spreading Happiness",
    "Fulfilling Adventure",
    "Creating Memories",
    "Connecting People"
];

const testimonials = [
    {
        text: "Komal Network has transformed our business operations with their fast and stable network solutions.",
        author: "AMIT SHARMA"
    },
    {
        text: "Reliable service and excellent customer support. Highly recommended!",
        author: "PRIYA DESAI"
    },
    {
        text: "Their customized plans suited our startup perfectly. Great value!",
        author: "RAHUL KUMAR"
    }
];

function LandingComponent() {
    const [text, setText] = useState("");
    const [indexhandle, setIndexhandle] = useState(0);
    const [messageIndex, setMessageIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState();
    const [email, setEmail] = useState('');
    const [requirement, setRequirement] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState();
    const [emailError, setEmailError] = useState('');
    const [requirementError, setRequirementError] = useState('');
    useEffect(() => {
        const currentMessage = messages[messageIndex];
        const timer = setTimeout(() => {
            if (charIndex < currentMessage.length) {
                setText((prev) => prev + currentMessage[charIndex]);
                setCharIndex((prev) => prev + 1);
            } else {
                setTimeout(() => {
                    setText("");
                    setCharIndex(0);
                    setMessageIndex((prev) => (prev + 1) % messages.length);
                }, 2000);
            }
        }, 100);
        return () => clearTimeout(timer);
    }, [charIndex, messageIndex]);

    const navigate = useNavigate();
    const [productDetails, setProductDetails] = useState([]);
    const [isFormFixed, setIsFormFixed] = useState(false);
    const [coverImageDetails, setCoverImageDetails] = useState([]);
    const [internationalList, setInternationalList] = useState([]);
    const [domesticList, setDomesticList] = useState([]);
    const [weekendList, setWeekendList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [honeymoonList, setHoneymoonList] = useState([]);
    const [southIndiaList, setSouthIndiaList] = useState([]);
    const [northIndiaList, setNorthIndiaList] = useState([]);
    const [adventureTourList, setAdventureTourList] = useState([]);
    const [heroSeriesList, setHeroSeriesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [internationalExploreName, setInternationalExploreName] = useState("International");
    const [domesticExploreName, setDomesticExploreName] = useState("Domestic");
    const [weekendExploreName, setWeekendExploreName] = useState("Weekend");
    const [groupExploreName, setGroupExploreName] = useState("Group");
    const [honeymoonExploreName, setHoneymoonExploreName] = useState("Honeymoon");
    const [southIndiaExploreName, setSouthIndiaExploreName] = useState("SouthIndia");  // New
    const [northIndiaExploreName, setNorthIndiaExploreName] = useState("NorthIndia");  // New
    const [adventureTourExploreName, setAdventureTourExploreName] = useState("AdventureTour");  // New
    const [heroSeriesExploreName, setHeroSeriesExploreName] = useState("HeroSeries");  // New
    const carouselRefOne = useRef(null);
    const carouselRefTwo = useRef(null);
    const carouselRefThree = useRef(null);
    const carouselRefFour = useRef(null);
    const carouselRefFive = useRef(null);
    const carouselRefSix = useRef(null); // New
    const carouselRefSeven = useRef(null); // New
    const carouselRefEight = useRef(null); // New   
    const carouselRefNine = useRef(null); // New
    const scrollCarousel = (ref, direction = 'right') => {
        const scrollAmount = window.innerWidth < 768 ? 200 : 300;
        if (ref?.current) {
            ref.current.scrollBy({
                left: direction === 'right' ? scrollAmount : -scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const handlePrev = () => {
        setIndexhandle((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setIndexhandle((prev) => (prev + 1) % testimonials.length);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getAllRoute();
        getAllRouteById();
        getAllTripType();
    }, []);

    const getAllRoute = () => {
        setIsLoading(true)
        axios({
            url: `${environment.config.apiBaseUrl}route/getAllRoutePackages`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setProductDetails(res.data);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                }
            })
            .catch((error) => {
                toast.error('Something went wrong.Please try again.');
            })
            .finally(() => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            })
    }
    const handleChangeName = (event) => {
        const value = event.target.value
        if (!value) {
            setNameError('Please provide valid Information')
        } else {
            setNameError('')
        }
        setName(value);
    }
    const handleChangeEmail = (event) => {
        const value = event.target.value
        if (!value) {
            setEmailError('Please provide valid Information')
        } else {
            setEmailError('')
        }
        setEmail(value);
    }
    const handleChangePhone = (event) => {
        const value = event.target.value
        if (!value) {
            setPhoneNumberError('Please provide valid Information')
        } else {
            setPhoneNumberError('')
        }
        setPhoneNumber(value);
    }
    const handleChangeRequirement = (event) => {
        const value = event.target.value
        if (!value) {
            setRequirementError('Please provide valid Information')
        } else {
            setRequirementError('')
        }
        setRequirement(value);
    }
    const handleClearForm = () => {
        setName('');
        setPhoneNumber('');
        setEmail('');
        setRequirement('');
        setNameError('');
        setPhoneNumberError('');
        setEmailError('');
        setRequirementError('');
    }
    const handleSubmitContact = async (event) => {
        event.preventDefault();
        let isValid = true;
        if (!name) {
            setNameError('Please provide valid information');
            isValid = false;
        }
        if (!phoneNumber) {
            setPhoneNumberError('Please provide valid information');
            isValid = false;
        }
        if (!email) {
            setEmailError('Please provide valid information');
            isValid = false;
        }
        if (!requirement) {
            setRequirementError('Please provide valid information');
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        setIsLoading(true);
        const requestBody = {
            "name": name,
            "phoneNumber": phoneNumber,
            "email": email,
            "requirement": requirement
        }
        try {
            const response = await axios.post(`${environment.config.apiOrderUrl}contact/contactToAdmin`, requestBody);
            if (response && response.data) {
                toast.success("Mail sent successfully to Admin!");
                handleClearForm();
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);

            }
        } catch (error) {
            toast.error('Something went wrong please try again!');
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
        }
    }


    const onPackageClick = (event, destination) => {
        const data = {
            packaageInfo: destination
        }
        navigate(`/package-details/:${destination.packageUID}`);
    }

    const getAllRouteById = () => {
        axios({
            url: `${environment.config.apiBaseUrl}package/getAllCoverImagesDetails`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setCoverImageDetails(res.data);
                }
            })
            .catch((err) => { });
    }

    const getAllTripType = () => {
        axios({
            url: `${environment.config.apiBaseUrl}route/getAllTripData`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setDomesticList(res.data.domesticList);
                    setInternationalList(res.data.internationalList);
                    setGroupList(res.data.groupList);
                    setWeekendList(res.data.weekendList);
                    setHoneymoonList(res.data.honeymoonList);
                    setSouthIndiaList(res.data.southIndia);
                    setNorthIndiaList(res.data.northIndia);
                    setAdventureTourList(res.data.adventureTour);
                    setHeroSeriesList(res.data.heroSeries);
                    console.log(res.data.southIndia.map(item => item?.packageUID));
                }
            })
            .catch((err) => {
                console.error("Error fetching trip types:", err);
            });
    };

    return (
        <>
            {isLoading &&
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backdropFilter: "blur(5px)",
                        backgroundColor: "rgba(0, 0, 0, 0.4)"
                    }}
                    open={isLoading}
                >
                    <CustomSpinner color="inherit" />
                </Backdrop>
            }
            <div className="stickyheader">
                <Header></Header>
                <NewNavBar className='newnavbartoggle' />
            </div>
            <Sidebar className='sidebartoggle' />
            <>
                <Toaster
                    position="top-right"
                    reverseOrder={false}
                />
                <div className="video-banner">
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        poster="https://images.wanderon.in/new-homepage-data/Hero%20Section/hero-thumbnail-new"
                    >
                        <source
                            src="https://d1c8wbldjj3tey.cloudfront.net/header-video+(1080p).mp4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>

                    <div className="banner-text">
                        <h1>Global Community for Travelers</h1>
                        <p className="typewriter-text">{text}</p>
                    </div>
                </div>
                {/* <div class="about-low-area section-padding2">
                    <div class="container">
                        <div class="row justify-content-between">
                            <div class="col-xl-5 col-lg-6 col-md-9">
                                <div class="about-img">
                                    <img src={aboutus} alt="" />
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-10">
                                <div class="about-caption mb-50">
                                    <div class="section-tittle mb-35">
                                        <h2>Ghoomo World </h2>
                                    </div>
                                    <p>
                                        Welcome to <strong>Ghoomo</strong> – your trusted travel partner for unforgettable journeys!
                                        We specialize in curating personalized travel experiences that connect you with the soul of every destination.
                                        Whether you're looking for a relaxing beach holiday, a cultural city tour, or an adventurous mountain trek,
                                        our team is dedicated to turning your travel dreams into reality.
                                    </p>
                                    <p>
                                        At Ghoomo, we believe that travel is more than just a getaway — it's a way to explore, connect, and grow.
                                        With a strong network of local partners, customized packages, and 24/7 support,
                                        we ensure a seamless and memorable journey every time you travel with us.
                                    </p>
                                    <p>
                                        Let's explore the world together. Because with Ghoomo, <em>it's not just travel — it's a story worth sharing.</em>
                                    </p>
                                </div>
                                <Link to="/about-us" className="explore-btn">About Us</Link>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="container mt-3 ">
                    <div
                        className="trip-section-data"
                        style={{
                            backgroundImage: 'url(https://wanderon-images.gumlet.io//uct-desktop-new.webp?updatedAt=1738909844156)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center', // center the image
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                    </div>
                </div>
                {internationalList && internationalList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/international_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>International Trips</h1>
                                    <p>Discover the world, one destination at a time</p>
                                    <Link to={`/explore/${internationalExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel ">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefOne, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefOne}>
                                    {internationalList.map((destination, idx) => (
                                        <div
                                            onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className="card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer', // <-- Add this line
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefOne, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}
                {/* <div className="about-area2 testimonial-area section-padding2 fix">
                    <div className="container">
                        <div className="row align-items-center">
                            <div class=" col-lg-6 col-md-9 col-sm-9">
                                <div className="about-caption">
                                    <div class="section-tittle mb-55">
                                        <h2>What our clint think about us!</h2>
                                    </div>
                                    <p className="h1-testimonial-active slick-initialized slick-slider  mb-4">
                                        <div class="single-testimonial">
                                            <div class="testimonial-caption">
                                                <p> {testimonials[indexhandle].text}</p>
                                                <div class="rattiong-caption">
                                                    <span>{testimonials[indexhandle].author}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </p>
                                    <div className="mt-6 gap-4 align-items-center">
                                        <button onClick={handlePrev} className="slick-prev slick-arrow">
                                            ←
                                        </button>
                                        <button onClick={handleNext} className="slick-next slick-arrow">
                                            →
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-11 col-sm-11">
                                <div className="about-img2">
                                    <img src={about2} alt="Testimonial" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {Array.isArray(domesticList) && domesticList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/india_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>Domestic Trips</h1>
                                    <p>A Journey Through Time, Colour And Culture</p>
                                    <Link to={`/explore/${domesticExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>

                                </div>
                            </div>
                            <div className="travel-carousel">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefTwo, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefTwo}>
                                    {domesticList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className="card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefTwo, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}

                <div className="container mt-3 ">
                    <div
                        className="trip-section-data"
                        style={{
                            backgroundImage: 'url(https://wanderon-images.gumlet.io//uct-desktop-new.webp?updatedAt=1738909844156)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center', // center the image
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                    </div>
                </div>
                <UpcomingTrips />
                {Array.isArray(southIndiaList) && southIndiaList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/india_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>South India Trips</h1>
                                    <p>A Journey Through Time, Colour And Culture</p>
                                    <Link to={`/explore/${southIndiaExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefSix, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefSix}>
                                    {southIndiaList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className="card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefSix, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}


                {Array.isArray(northIndiaList) && northIndiaList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/india_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>North India Trips</h1>
                                    <p>A Journey Through Time, Colour And Culture</p>
                                    <Link to={`/explore/${northIndiaExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefSeven, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefSeven}>
                                    {northIndiaList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className="card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefSeven, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}
                <div className="container mt-3 ">
                    <div
                        className="trip-section-data"
                        style={{
                            backgroundImage: 'url(https://wanderon-images.gumlet.io//uct-desktop-new.webp?updatedAt=1738909844156)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center', // center the image
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                    </div>
                </div>
                {Array.isArray(adventureTourList) && adventureTourList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/india_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>Adventure Tour Trips</h1>
                                    <p>Discover the world, one destination at a time</p>
                                    <Link to={`/explore/${adventureTourExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefEight, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefEight}>
                                    {adventureTourList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className="card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefEight, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}

                {Array.isArray(heroSeriesList) && heroSeriesList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/india_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>Hero Series Trips</h1>
                                    <p>Discover the world, one destination at a time</p>
                                    <Link to={`/explore/${heroSeriesExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefNine, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefNine}>
                                    {heroSeriesList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className="card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefNine, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}

                <div className="container mt-3">
                    <div class="banner-Adventure">
                        <div class="text-content">
                            <h1>Dreaming of your next <span>Adventure?</span></h1>
                            <p>Hit us up!</p>
                            <button>Connect Now</button>
                        </div>
                    </div>
                </div>

                {Array.isArray(groupList) && groupList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/international_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>Group Trips</h1>
                                    <p>Discover the world, one destination at a time</p>
                                    <Link to={`/explore/${groupExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel ">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefThree, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefThree}>
                                    {groupList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className=" card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefThree, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}
                <div class="why-use-ghoomo">
                    <div className="section-tittle"> <h2>Why Ghoomo World?</h2></div>
                    <div class="cards">
                        <div class="card">
                            <h3>Personalised Travel Planning</h3>
                            <p>Every journey is thoughtfully designed around your destination, budget, travel dates and preferences.</p>
                        </div>
                        <div class="card">
                            <h3>Transparent Pricing</h3>
                            <p>Clear quotations with complete details about hotels, transportation, inclusions and exclusions—no hidden surprises.</p>
                        </div>
                        <div class="card">
                            <h3>Trusted Travel Partners</h3>
                            <p>Carefully selected hotels, experienced drivers and reliable local partners ensure a comfortable and well-managed experience.</p>
                        </div>
                        <div class="card">
                            <h3>Support Throughout Your Journey</h3>
                            <p>From your first enquiry until you return home, the Ghoomo World team is always available to assist you.</p>
                        </div>
                    </div>
                </div>
                {Array.isArray(weekendList) && weekendList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/international_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>Weekend Trips</h1>
                                    <p>Discover the world, one destination at a time</p>
                                    <Link to={`/explore/${weekendExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel ">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefFour, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefFour}>
                                    {weekendList.map((destination, idx) => (
                                        <div onClick={(event) => onPackageClick(event, destination)}
                                            key={idx}
                                            className=" card-data-info"
                                            style={{
                                                backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                border: '3px solid white',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <div className="card-info-data">
                                                <h2>{destination.routeName}</h2>
                                                <p>Starting Price {destination.startingPrices}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefFour, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}
                {Array.isArray(honeymoonList) && honeymoonList.some(item => item?.packageUID != null) ? (
                    <div className="container mt-3 ">
                        <div className='travel-hero-landing'>
                            <div className="travel-hero">
                                <video autoPlay muted loop playsInline className="bg-video">
                                    <source
                                        src="https://d1c8wbldjj3tey.cloudfront.net/category-section/honeymoon_(1)+(540p).mp4"
                                        type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="hero-content">
                                    <h1>Honeymoon Trips</h1>
                                    <p>Where Forever Begins...Together!</p>
                                    <Link to={`/explore/${honeymoonExploreName}`} target="_blank" className="explore-btn">
                                        Explore
                                    </Link>
                                </div>
                            </div>
                            <div className="travel-carousel ">
                                <button className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile nav-btn-data left" onClick={() => scrollCarousel(carouselRefFive, 'left')}>&#10094;</button>
                                <div className="carousel-track" ref={carouselRefFive}>
                                    {honeymoonList.length === 0 ? (
                                        <div className="card-info-data">
                                            <h2>No destinations available</h2>
                                        </div>
                                    ) : (
                                        honeymoonList.filter(destination => destination?.packageUID != null).map((destination, idx) => (
                                            <div onClick={(event) => onPackageClick(event, destination)}
                                                key={idx}
                                                className="card-data-info"
                                                style={{
                                                    backgroundImage: `url('${destination?.coverImages ? destination.coverImages : "https://images.wanderon.in/uct-desktop-new?updatedAt=1738909844156"}')`,
                                                    border: '3px solid white',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <div className="card-info-data">
                                                    <h2>{destination.routeName}</h2>
                                                    <p>Starting Price {destination.startingPrices}</p>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                                <button className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile nav-btn-data right" onClick={() => scrollCarousel(carouselRefFive, 'right')}>&#10095;</button>
                            </div>
                        </div>
                    </div>) : null}
                <JourneyFrames />
                <YoutubeSection/>
                <div class="about-low-area section-padding2">
                    <div className="container">
                        <div className="card shadow-sm border-0" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                            <div className="row g-0 align-items-center" style={{ backgroundColor: '#fff099' }}>
                                <div className="col-lg-6 d-flex justify-content-center align-items-center" >
                                    <img src={aboutus} alt="Contact Illustration" className="img-fluid" style={{ maxHeight: '400px' }} />
                                </div>
                                <div className="col-lg-6 bg-white p-4">
                                    <div style={{ background: '#fffbdf', padding: '20px', borderRadius: '10px 10px 0 0' }}>
                                        <h5 className="mb-1" style={{ color: '#ffe100', fontWeight: '700' }}>GhoomoWorld Calling?</h5>
                                        <h6 className="fw-bold mb-0">Allow Us to Call You Back!</h6>
                                    </div>

                                    <div className="card-body px-4 py-5" style={{ backgroundColor: '#f9fcff', borderRadius: '12px', boxShadow: '0 8px 20px rgba(0,0,0,0.08)' }}>

                                        <form className="from-contact-web mt-4">
                                            <div className="form-group">
                                                <i className="fas fa-user form-icon "></i>
                                                <input type="text" id="name" className="form-control" placeholder=" " required value={name} onChange={handleChangeName} />
                                                <label htmlFor="name" className="form-label">Name</label>
                                                {nameError && <p className="error-text" style={{ fontSize: '10px', color: 'red' }}>{nameError}</p>}
                                            </div>
                                            <div className="form-group">
                                                <i className="fas fa-phone form-icon"></i>
                                                <input type="tel" id="phone" className="form-control" placeholder=" " required onChange={handleChangePhone} value={phoneNumber} />
                                                <label htmlFor="phone" className="form-label">Phone Number</label>
                                                {phoneNumberError && <p className="error-text" style={{ fontSize: '10px', color: 'red' }}>{phoneNumberError}</p>}
                                            </div>
                                            <div className="form-group">
                                                <i className="fas fa-envelope form-icon"></i>
                                                <input type="email" id="email" className="form-control" placeholder=" " required onChange={handleChangeEmail} value={email} />
                                                <label htmlFor="email" className="form-label">Email</label>
                                                {emailError && <p className="error-text" style={{ fontSize: '10px', color: 'red' }}>{emailError}</p>}
                                            </div>
                                            <div className="form-group">
                                                <i className="fas fa-comment-dots form-icon"></i>
                                                <textarea id="message" className="form-control" placeholder=" " onChange={handleChangeRequirement} value={requirement}></textarea>
                                                <label htmlFor="message" className="form-label">Your Requirement</label>
                                                {requirementError && <p className="error-text" style={{ fontSize: '10px', color: 'red' }}>{requirementError}</p>}
                                            </div>
                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    className="btn text-dark"
                                                    style={{
                                                        backgroundColor: '#ffe100',
                                                        borderRadius: '30px',
                                                        fontWeight: 'bold',
                                                        padding: '12px 0',
                                                        fontSize: '16px',
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                    }}
                                                    onClick={handleSubmitContact}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            <Footer />
        </>
    );
}
export default LandingComponent;